import { roundToPrecision } from './numberFormatter';

export const computeFloorPlaceholder = (
  marketPriceAllIn: number | null | undefined,
  accountFloorFraction: number | null | undefined
): string | undefined => {
  if (marketPriceAllIn == null || accountFloorFraction == null) {
    return undefined;
  }
  // Plain (no thousands separator) so consumers that parseFloat this string stay correct
  return roundToPrecision(marketPriceAllIn * accountFloorFraction, 2).toFixed(
    2
  );
};
